function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-204.57 -103.81)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 182.74 99.1)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.76 -5.1174)",
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(35.761 22.741)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.872 0.19098c-0.745-0.011-1.464 0.278-1.993 0.804l-8.825 9.038c-3.343 3.34 2.164 3.061 4.154 4.325 0.922 0.602-2.955 1.371-2.164 2.164 0.771 0.793 4.65 1.521 5.422 2.293 0.771 0.791-1.564 1.627-0.793 2.418 0.75 0.793 2.549 0.043 2.87 1.842 0.235 1.328 3.3 0.666 4.672-0.471 0.854-0.729-1.479-0.729-0.708-1.521 1.929-1.949 3.642-0.875 4.349-2.676 0.387-0.963-2.913-1.65-2.034-2.271 2.101-1.477 9.812-2.227 6.255-5.782l-9.147-9.359c-0.56-0.521-1.295-0.807-2.058-0.804zm0.075 0.859c0.529 3e-3 1.06 0.201 1.444 0.584l3.492 3.557c0.323 0.321 0.323 0.986 0.129 1.178l-1.734-1.412-0.343 2.077-1.435-0.772-2.336 1.478-0.771-3.105-1.242 2.698-3.107-0.022c-0.6 0-0.514-0.621 0.107-1.242 1.221-1.35 3.6-3.64 4.35-4.433 0.385-0.396 0.915-0.589 1.445-0.584zm9.755 16.276c-0.74 0.025-1.496 0.395-1.689 1.08 0 0.449 3.492 0.707 3.301-0.107-0.141-0.686-0.87-1.002-1.611-0.975v2e-3zm-15.346 1.945c-1.008 0.059-2.088 0.791-1.232 1.512 0.791 0.686 1.992-0.15 2.377-1.113-0.24-0.316-0.686-0.426-1.143-0.398h-2e-3zm13.229 0.077c-0.986 0.9 0.17 1.842 1.134 1.221 0.258-0.173-0.021-1.005-1.134-1.221z",
  fill: "#fffafa"
})))));

function SvgInskcape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.3501mm",
    height: "6.2494mm",
    viewBox: "0 0 6.3501 6.2494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInskcape);
export default __webpack_public_path__ + "static/media/inskcape.31073b25.svg";
export { ForwardRef as ReactComponent };